<div *ngIf="!loading" class="container-fluid px-md-5">
  <div *ngIf="!enableTablasForm" class="row pt-5">
    <div class="col-md-12 pt-4">
      <button
        mat-mini-fab
        matTooltip="{{ 'TABLES.ADD_VALUES' | translate }}"
        matTooltipPosition="above"
        matTooltipClass="addAlarm"
        class="float-right addUser1"
        (click)="confirmaddTable()"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  <div *ngIf="!enableTablasForm" class="p-3">
    <div class="row mt-3">
      <div class="col-md-12">
        <mat-form-field class="input-full-width" appearance="outline">
          <mat-label>{{ "TABLES.SELECT_TABLE" | translate }}</mat-label>
          <mat-select
            (selectionChange)="changeSelection($event)"
            [(value)]="tableSelected"
          >
            <mat-option *ngFor="let tab of tableCollection" [value]="tab.uuid">
              {{ browserLang == "en" ? tab.nombre_en : tab.nombre_es }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <mat-form-field class="filtro-tabla">
        <mat-label>Filtrar</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Buscar valor..."
          [disabled]="!tableSelected"
        />
      </mat-form-field>

          <div class="table-container mat-elevation-z2">
              <table mat-table [dataSource]="dataSource" *ngFor="let table of tables">
                <ng-container *ngFor="let itemColumn of tableFieldCollection" [matColumnDef]="itemColumn.uuid">
                  <th mat-header-cell *matHeaderCellDef> {{ browserLang == "en" ? itemColumn.nombre_en : itemColumn.nombre_es }}</th>
                  <ng-container *ngIf="itemColumn.tipo=='Object'">
                    <td mat-cell *matCellDef="let element">
                        <a class='ver_mas_nodos' href='#'  [attr.data-record-id]="element.id"
                        [attr.data-field-uuid]="itemColumn.uuid"
                         (click)='getViewMore($event)'>Ver más...</a>
                    </td>                  
                  </ng-container>
                  <ng-container *ngIf="itemColumn.tipo!='Object'">
                    <td mat-cell *matCellDef="let element">{{ element[itemColumn.uuid] ? element[itemColumn.uuid].value : "" }}</td>                  
                  </ng-container>
                </ng-container>
                <ng-container matColumnDef="actions" [stickyEnd]="true">
                    <th mat-header-cell *matHeaderCellDef>Acciones </th>
                    <td mat-cell *matCellDef="let element"> 
                        <div style="width: 75px">
                            <div class="removeAlarmButton">
                                <app-svg matTooltip="{{'TABLES.DELETE_VALUE' | translate}}" matTooltipPosition='above'
                                    matTooltipClass='deleteAlarm1' class="fillWhite" name="deleteAlarm" (click)="deleteRecord(element)" ></app-svg> 
                            </div>
                            <div class="editAlarmButton">
                                <app-svg matTooltip="{{'TABLES.EDIT_VALUE' | translate}}" matTooltipPosition='above'
                                    matTooltipClass='editAlarm1' class="fillWhite" name="editAlarm" (click)="editRecord(element)"></app-svg> 
                            </div>
                        </div>
                    </td>
                  </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
             
            </div>
            <mat-paginator style="width: 100%;" [pageSizeOptions]="[10,15,25,50]" showFirstLastButtons></mat-paginator>     
      </div>
      <!-- <mat-paginator style="width: 100%;" [pageSizeOptions]="[3, 10, 20]" showFirstLastButtons></mat-paginator>-->
    </div>
  </div>

  <app-tablas-form
    *ngIf="enableTablasForm"
    [fieldsTable]="tableFieldCollection"
    [recordToEdit]="dataToEdit"
    [formMode]="formMode"
    [tableSelected]="tableSelected"
    (cancelEmitter)="cancelForm()"
    (editEmitter)="saveEditForm($event)"
    (addEmitter)="saveAddForm($event)"
  >
  </app-tablas-form>

  <app-loading *ngIf="loading" [loadingText]="'Cargando...'"></app-loading>
